import clsx from 'clsx';
import { useMergedStyles } from 'hooks/useMergedStyles';
import { FC } from 'react';
import { Styles } from 'types/styles';
import Check from '../Icons/LandingPageIcons/Check';

import styles from './MenuItem.module.scss';

type Props = {
  newStyles?: Styles;
  isMultiSelect?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

const MenuItem: FC<Props> = ({
  newStyles = {},
  isMultiSelect = false,
  isSelected = false,
  onClick,
  disabled,
  children,
}) => {
  const mergedStyles = useMergedStyles(styles, newStyles);

  return (
    <div
      className={clsx(mergedStyles['menu-item'], {
        [mergedStyles.selected]: isSelected,
        [mergedStyles.disabled]: disabled,
      })}
      onClick={onClick}
    >
      {children}
      <label
        className={clsx({
          [mergedStyles.multi]: isMultiSelect,
        })}
      >
        {isMultiSelect ? <Check /> : <span />}
      </label>
    </div>
  );
};

export default MenuItem;
